import { createLifecycleFor } from 'ext/lib/collections';

export const TYPE = 'apps';

export const { patterns, resolve, reject } = createLifecycleFor(TYPE);
